import { FC, useEffect, useRef, useState } from "react";

import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/_atoms/hover-card";

interface RightAsideRowProps {
  label: string;
  value?: string;
}

export const RightAsideRow: FC<RightAsideRowProps> = ({ label, value }: RightAsideRowProps) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
      }
    };

    checkTruncation();
    window.addEventListener("resize", checkTruncation);
    return () => window.removeEventListener("resize", checkTruncation);
  }, [value]);

  const content = (
    <div className="flex w-full flex-row items-start gap-3 overflow-x-hidden">
      <div className="mt-2 w-24 shrink-0 font-medium">{label}</div>
      <div className="mt-2 min-w-0 flex-1">
        <span ref={textRef} className="block truncate text-sm">
          {value ?? "-"}
        </span>
      </div>
    </div>
  );

  if (isTruncated) {
    return (
      <HoverCard>
        <HoverCardTrigger>{content}</HoverCardTrigger>
        <HoverCardContent side="top" className="w-auto p-2">
          {value}
        </HoverCardContent>
      </HoverCard>
    );
  }

  return content;
};
